import * as DateFns from 'date-fns'
import { enUS, sv } from 'date-fns/locale'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

const locales: Record<string, DateFns.Locale> = {
  en: enUS,
  sv,
}

export function configureDateFns(language: string, fallbackLanguage: string) {
  DateFns.setDefaultOptions({
    locale: locales[language] ?? locales[fallbackLanguage],
    weekStartsOn: 1,
  })
}

export const useDateFnsConfiguration = (fallbackLanguage = 'sv') => {
  const { i18n } = useTranslation()

  useEffect(() => {
    configureDateFns(i18n.language, fallbackLanguage)
  }, [i18n.language, fallbackLanguage])
}
